import { z } from 'zod'

import type { Incident } from '@collector/sportsapi-client'
import type {
  ApiError,
  Event,
  EventsLineups,
  ShortEventInfo,
} from '@collector/sportsapi-client-legacy'

import type { Topic } from '../websocket/index.js'

export enum RabbitMessageType {
  Error = 'error',
  Event = 'event',
  EventsLineups = 'events_lineups',
  Incident = 'incident',
  EventsScouts = 'events_scouts',
  BasicLivescore = 'basic_livescore',
}

export type RabbitMessageTopic = `events/${number}/${string}`
export type RabbitMessageTopicParsed = {
  eventId: number
  type: RabbitMessageType
}
export function parseRabbitTopic(topic: Topic): RabbitMessageTopicParsed {
  const parts = topic.split('/')
  const eventId = +parts[1]
  const type = z.nativeEnum(RabbitMessageType).parse(parts[2])
  if (parts.length !== 3) throw Error(`Invalid topic ${topic}`)
  else return { eventId, type }
}

export type RabbitMessage<TMessageType extends RabbitMessageType, TData> = {
  id: number
  uuid: string
  type: TMessageType
  ut: number
  source: number
  data: TData
}

export type RabbitIncidentMessage = RabbitMessage<
  RabbitMessageType.Incident,
  Incident
>

export type RabbitErrorMessage = RabbitMessage<
  RabbitMessageType.Error,
  ApiError
>

export type RabbitEventMessage = RabbitMessage<RabbitMessageType.Event, Event>

export type RabbitEventsScoutsMessage = RabbitMessage<
  RabbitMessageType.EventsScouts,
  ShortEventInfo
>

export type RabbitEventsLineupsMessage = RabbitMessage<
  RabbitMessageType.EventsLineups,
  EventsLineups
>
